<template>
  <span class="survey-radio">
    <input
      type="radio"
      :checked="checked"
      :name="name"
      :value="value"
      class="survey-radio__input"
      @change="onChange($event.target.value)"
    />
    <span class="survey-radio__custom"></span>
  </span>
</template>

<script>
export default {
  name: "SurveyRadio",
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.survey-radio {
  position: relative;

  &__input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  &__custom {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #c2c2c8;
    background-color: transparent;
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
    transition: border-color 0.2s;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #f4b63f;
      opacity: 0;
      transition: opacity 0.2s;
    }
  }

  &__input:checked + &__custom {
    border-color: #f4b63f;

    &::after {
      opacity: 1;
    }
  }
}
</style>
